<mat-nav-list>
    <a href="{{portalUrl}}" mat-list-item (click)="onSidenavClose()">
        <span class="k-icon item-icon custom-icon portal-icon"></span>
        <span class="nav-caption">Return to Tessellon Portal</span>
    </a>
    <a mat-list-item routerLink="" (click)="onSidenavClose()">
        <span class="k-icon item-icon custom-icon k-i-search"></span>
        <span class="nav-caption">VennHealth™</span>   
    </a>
    <a mat-list-item routerLink="about" (click)="onSidenavClose()">
        <span style="color: white;" class="k-icon item-icon custom-icon k-i-information"></span>
        <span class="nav-caption">About VennHealth™</span>
    </a>
</mat-nav-list>
